define('Store.Login.LoadingCart.View', [
    'Backbone',
    'store_login_loadingcart_view.tpl',
    'Utils',
    'SC.Configuration',
    'Utilities.CookieJar',
    'Store.Cookie'
], function StoreLoginLoadingCartView(
    Backbone,
    storeLoginLoadingCartViewTpl,
    Utils,
    Configuration,
    CookieJar,
    StoreCookie
) {
    'use strict';

    return Backbone.View.extend({
        template: storeLoginLoadingCartViewTpl,
        initialize: function initialize() {
            var self = this;
            var url;
            var Model = Backbone.Model.extend({
                url: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/Store.Profile.Service.ss'))
            });
            var model = new Model({ internalid: this.options.response && this.options.response.user.store.internalid, isLogin: true });
            this.application = this.options.application;

            model.save().done(function (storeResponse) {
                StoreCookie.set(model.get('internalid'));
                CookieJar.setItem('needsCartCheck', 'true');
                if (!self.options.isPasswordReset &&
                    (self.options.is === 'checkout' || self.options.origin === 'checkout')
                ) {
                    self.options.callback.call(self, _.extend(self.options.response, storeResponse));
                } else if (self.options.origin && self.options.touchpoints[self.options.origin]) {
                    url = self.options.touchpoints[self.options.origin];
                    if (self.options.origin_hash) {
                        url = Utils.addParamsToUrl(url, { fragment: self.options.origin_hash });
                    }

                    window.location.href = url;
                } else if (
                    Configuration.getRegistrationType() !== 'disabled' &&
                    SC.ENVIRONMENT.siteSettings.siteloginrequired === 'T'
                ) {
                    window.location.href = self.options.touchpoints.home;
                } else {
                    window.location.href = self.options.touchpoints.customercenter;
                }
            });

        },
        getContext: function getContext() {
            return {

            };
        }
    });
});
